import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange"];
import { SelectBase, SelectWrapper } from './SelectBase';
import { jsx as _jsx } from "react/jsx-runtime";
export function Select(_ref) {
  let {
      onChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleOnChange = event => {
    onChange(event.target.value);
  };
  return /*#__PURE__*/_jsx(SelectBase, Object.assign({}, rest, {
    onChange: handleOnChange
  }));
}
Select.Wrapper = SelectWrapper;